export default __webpack_public_path__ + "static/media/phoneGrey.f61be16e.svg";